import { Badge, Group } from '@mantine/core';
import BadgeDeleted from 'components/Badge';
import P2Regular from 'components/typography/P2Regular';
import P3Regular from 'components/typography/P3Regular';

/** Renders the canonical hierarchy identifier. */
export function HierarchyIdCell({ value }: { value?: number }) {
  return value === undefined ? null : <P3Regular>{value}</P3Regular>;
}

/** Renders the hierarchy identity and retained/default state. */
export function HierarchyNameCell({ data }: { data?: { hierarchyName: string; isDefault: boolean; status: boolean } }) {
  if (!data) return null;
  return (
    <Group spacing={8} noWrap>
      <P2Regular color="gray.8">{data.hierarchyName}</P2Regular>
      {data.isDefault && <Badge color="blue">Predvolená</Badge>}
      {!data.status && <BadgeDeleted text="Vyradená" />}
    </Group>
  );
}

/** Renders hierarchy level labels. */
export function HierarchyLevelsCell({ value }: { value?: string }) {
  return value ? <P2Regular>{value}</P2Regular> : null;
}

/** Renders directly assigned organization names. */
export function HierarchyOrganizationsCell({ value }: { value?: string }) {
  return value ? <P2Regular>{value}</P2Regular> : null;
}
